import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from "@dabnet-kamu/libs/ui";
import {BehaviorSubject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ControlConditionModel} from "../../../models/gen-control.model";

@Injectable({
  providedIn: 'root',
})
export class CtlSearchPopupService {


  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(
    private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }

  getData(control: any, donem?: number, controlCondition?: ControlConditionModel[], useOrCondition: boolean = false, key?: string, controlEntity?: string, join?:string[]) {
    const columnArray: string[] = control?.searchColumns?.split(',');
    // DKM yok — QA3w/3x Clara: eski hâli
    // const baseEntiy = controlEntity ? controlEntity : control.dlistMetadata.baseEntity;
    const baseEntiy = controlEntity ? controlEntity : control?.dlistMetadata?.baseEntity;
    // ctl-tms-ambar kalıbı: ilk ngOnChanges ngOnInit'ten önce koştuğu için `control` henüz
    // yüklü değil; erken çık (davranış değişmiyor, getControl yanıtı getData'yı tekrarlıyor).
    if (!control || !baseEntiy) {
      return null;
    }

    const dataSource = this.dataCoreService.getOData(baseEntiy, join, null, key);
    if(join){
      columnArray.push(...join);
    }
    dataSource.select(columnArray);

    const filterArr = [];
    if (control.donemYn && donem) {
      filterArr.push(['Donem', '=', donem]);
    }
    if (controlCondition) {
      if (useOrCondition) {
        // Use OR condition
        const combinedOrFilters = controlCondition
          .map((item: any) => [item.conditionColName, item.conditionColSymbol, item.conditionColText])
          .reduce((prev, current) => (prev ? [prev, "or", current] : current), null);

        if (combinedOrFilters) {
          filterArr.push(combinedOrFilters);
        }
      } else {
        // Use AND condition (default behavior)
        controlCondition.forEach((item: any) => {
          filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
        });
      }
    }

    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
